import SummaryReport from "./SummaryReport";

export default SummaryReport;
